import React from "react";
import ForgotPasswordpage from "./views/ForgotPasswordPage";
import { ForgotPasswordContextProvider } from "./ForgotPasswordView";
import ForgotPaswordContent from "../../constants/contentFile.json";
const ForgotPassword = () => {
  return (
    <ForgotPasswordContextProvider>
      <ForgotPasswordpage
        textConstants={ForgotPaswordContent.forgotPasswordPage}
      />
    </ForgotPasswordContextProvider>
  );
};
export default ForgotPassword;
